import { render, staticRenderFns } from "./CardProjectMoneyback.vue?vue&type=template&id=3c856b83&scoped=true&"
import script from "./CardProjectMoneyback.vue?vue&type=script&lang=js&"
export * from "./CardProjectMoneyback.vue?vue&type=script&lang=js&"
import style0 from "./CardProjectMoneyback.vue?vue&type=style&index=0&id=3c856b83&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c856b83",
  null
  
)

export default component.exports